import React from 'react';
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { BoolCell } from './SharedComponents';

const MODULE_RULES = [
    { name: 'Traffic Trends',         accessType: 'Yes / No',               adminView: true,  adminEdit: true,  regView: true,  regEdit: false, tourist: true },
    { name: 'Activities Tracker',     accessType: 'Vendor scope', adminView: true,  adminEdit: true,  regView: true,  regEdit: true,  tourist: true },
    { name: 'Activities MAP',         accessType: 'Vendor scope', adminView: true,  adminEdit: true,  regView: true,  regEdit: true,  tourist: true },
    { name: 'Activities Performance', accessType: 'Vendor scope', adminView: true,  adminEdit: true,  regView: true,  regEdit: true,  tourist: true },
];

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:hover': { backgroundColor: theme.palette.action.hover },
    '&:last-child td': { border: 0 },
}));

const ModuleRulesTable = () => (
    <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: 2 }}>
        <Table size="small">
            <TableHead>
                <TableRow sx={{ bgcolor: 'grey.50' }}>
                    <TableCell sx={{ fontWeight: 500, fontSize: 12 }}>Module</TableCell>
                    <TableCell sx={{ fontWeight: 500, fontSize: 12 }}>Access type</TableCell>
                    <TableCell align="center" sx={{ fontWeight: 500, fontSize: 12 }}>Admin view</TableCell>
                    <TableCell align="center" sx={{ fontWeight: 500, fontSize: 12 }}>Admin edit</TableCell>
                    <TableCell align="center" sx={{ fontWeight: 500, fontSize: 12 }}>Regular view</TableCell>
                    <TableCell align="center" sx={{ fontWeight: 500, fontSize: 12 }}>Regular edit own</TableCell>
                    <TableCell align="center" sx={{ fontWeight: 500, fontSize: 12 }}>Tourist view</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {MODULE_RULES.map((m) => (
                    <StyledTableRow key={m.name}>
                        <TableCell>
                            <Typography variant="body2" fontWeight={500}>{m.name}</Typography>
                        </TableCell>
                        <TableCell>
                            <Typography variant="caption" color="text.secondary">{m.accessType}</Typography>
                        </TableCell>
                        <BoolCell value={m.adminView} />
                        <BoolCell value={m.adminEdit} />
                        <BoolCell value={m.regView} />
                        <BoolCell value={m.regEdit} />
                        <BoolCell value={m.tourist} />
                    </StyledTableRow>
                ))}
            </TableBody>
        </Table>
    </TableContainer>
);

export default ModuleRulesTable;